import { atom, atomFamily } from 'recoil';
import { TDifotAccountabilityOwner, TDifotMetric } from '@types';

/* eslint-disable */
const keys = {
	DIFOT_SELECTED_METRIC:			'@Ofload/DifotSelectedMetric',
	DIFOT_SELECTED_ACCOUNTABILITY:	'@Ofload/DifotSelectedAccountability',
	DIFOT_SELECTED_REASON:			'@Ofload/DifotSelectedReason',
}
/* eslint-enable */

export const DifotSelectedMetric = atomFamily<TDifotMetric, number | null>({
	key: keys.DIFOT_SELECTED_METRIC,
	default: 'difot',
});

export const DifotSelectedAccountability = atom<TDifotAccountabilityOwner | null>({
	key: keys.DIFOT_SELECTED_ACCOUNTABILITY,
	default: null,
});

export type TDifotSelectedReason = {
	reason_code: string;
	pillar: string;
}

export const DifotSelectedReason = atom<TDifotSelectedReason | null>({
	key: keys.DIFOT_SELECTED_REASON,
	default: null,
});
